import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['progress']
  static values = { delay: { type: Number, default: 5000 } }

  connect () {
    this.hideTimer = null
    this.removeTimer = null

    requestAnimationFrame(() => {
      this.element.classList.remove('opacity-0', 'scale-95')
      this.element.classList.add('opacity-100', 'scale-100')
      this.startProgress()
    })

    this.hideTimer = window.setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect () {
    this.clearTimers()
  }

  close () {
    this.dismiss()
  }

  dismiss () {
    this.clearTimers()
    this.pauseProgress()
    this.element.classList.remove('opacity-100', 'scale-100')
    this.element.classList.add('opacity-0', 'scale-95')

    this.removeTimer = window.setTimeout(() => {
      this.element.remove()
    }, 280)
  }

  startProgress () {
    if (!this.hasProgressTarget) return

    const bar = this.progressTarget
    bar.style.transition = 'none'
    bar.style.transform = 'scaleX(1)'

    requestAnimationFrame(() => {
      bar.style.transition = `transform ${this.delayValue}ms linear`
      bar.style.transform = 'scaleX(0)'
    })
  }

  pauseProgress () {
    if (!this.hasProgressTarget) return

    const bar = this.progressTarget
    const width = bar.getBoundingClientRect().width
    const parentWidth = bar.parentElement.getBoundingClientRect().width
    const ratio = parentWidth > 0 ? width / parentWidth : 0

    bar.style.transition = 'none'
    bar.style.transform = `scaleX(${ratio})`
  }

  clearTimers () {
    if (this.hideTimer) {
      window.clearTimeout(this.hideTimer)
      this.hideTimer = null
    }
    if (this.removeTimer) {
      window.clearTimeout(this.removeTimer)
      this.removeTimer = null
    }
  }
}
